import { Component } from '@angular/core';
import { IonicPage, NavController,AlertController, NavParams,LoadingController } from 'ionic-angular';
import {AddressesPage} from '../addresses/addresses'

/**
 * Generated class for the UpdateaddressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updateaddress',
  templateUrl: 'updateaddress.html',
})
export class UpdateaddressPage {

  contactDtailsData:any={};
  contactOfficeDtailsData:any={};
  ladline:any=''
  constructor(private loadingCtrl:LoadingController,
    public navCtrl: NavController, public navParams: NavParams,private alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UpdatecontactPage',this.navParams);
    this.contactDtailsData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return res.addresstype=='CURRES' && res.applicanttype=='Applicant'
    })[0];
    
    this.contactOfficeDtailsData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return res.addresstype=='OFFICE' && res.applicanttype=='Applicant'
    })[0];
    this.ladline = this.contactDtailsData.stdcode+'-'+this.contactDtailsData.phone1
    //console.log(this.contactDtailsData,'contact data');

  }
  goToEditScreen(action,flag){
    //console.log(action)
    this.showAlert("Kindly visit our nearest branch with your original KYC documents for verification & updation","","")
    //this.navCtrl.push(AddressesPage,{queryParams:action,currentAdd:flag});
  }
  showAlert(msg,title,link) {
    const alert = this.alertCtrl.create({
      title:title,
      subTitle: msg,
      enableBackdropDismiss: false, 
      buttons: [{
          text: 'Ok',
          handler: data => {
             
              
          }
        }]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/updateaddress/updateaddress.ts